<template>
    <div :class="{
        'container': true,
        'pd-bot': firstBtnType
    }">
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img class="img" :src="item">
            <!-- <button v-if="index == 2" class="btn-more" @click="JumpFn">
                <img class="more-img" :src="buttonList.more2">
            </button> -->
            <button v-if="index == 3" class="btn-more" @click="JumpFn">
                <img class="more-img" :src="buttonList.more">
            </button>
            <div v-if="index == 3" class="sw">
                <div class="swiper-container current-container">
                    <div class="swiper-wrapper current-wraps">
                        <div
                            v-for="(value,inde) in swiperList"
                            :key="inde"
                            class="swiper-slide current-box"
                        >
                            <img class="company" :src="value"/>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="index == 6" class="sw1">
                <div class="swiper-container current-wrap">
                    <div class="swiper-wrapper current-wraps">
                        <div
                            v-for="(value,inde) in sectionSwiper.swiper"
                            :key="inde"
                            class="swiper-slide current-box"
                        >
                            <img class="company" :src="value"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showMask" class="form-mask">
            <div class="mask-content">
                <div class="mask-header">
                    <div>选择目标方向，领取干货礼包</div>
                    <div class="time">{{time}}s</div>
                </div>
                <div class="subject-content">
                    <div
                        class="subject-item"
                        :class="{'actived': item.subjectId == currentSubjectId}"
                        v-for="item in subjectList"
                        :key="item.subjectId"
                        @click="handleChangeSubject(item.subjectId)"
                    >{{ item.subjectName }}</div>
                </div>
                <div class="mask-btn" @click="handleSubmit">选好了</div>
            </div>
        </div>
        <template>
            <ClueFooter
                :bgStyle="{background: 'linear-gradient(90deg, #E34E43 0%, #C52F2F 100%)'}"
                v-if="firstBtnType"
                :id="68"
                :isDcsj="true"
                showPoup
                @jump="JumpFn('亮片名额有限立即抢占')"
            />
            <button class="footer" @click="JumpFn" v-else>
                <img class="img" :src="buttonList.footer">
                <img class="H5activityIcon" v-if="activity.isShow" :src="activity.H5icon">
                <FooterPoup
                    :id="68"
                    :isDcsj="true"
                />
            </button>
        </template>

    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import list from './list'
import activity from '../../../common/activity';
import FooterPoup from '../../../components/FooterPoup/index.vue'
import { fetchUserInfo, judgeSubmit, privateEducationV2, subjectList } from '../../../service/api'
export default {
    components: {
        FooterPoup
    },
    data() {
        return {
            list,
            activity:activity,//活动图标
            imgList:[],
            swiperList:[],
            buttonList:{},
            sectionSwiper:{},
            showMask: false,
            time: 5,
            userInfo: {},
            subjectList: [],
            key: "96e584784cb94c178ea397db3e409117",
            currentSubjectId: 1,
            submitted: false
        }
    },
    created () {
        // 用于判断不同userId显示底部按钮状态
        this.saLogin();
    },
    mounted () {
        setTimeout(()=>{
            this.eduPlatTrack('WebView', { page_id: 'k1sah'});
        },500)

        let dataList = this.list.data.h5;
        this.imgList = dataList.imgList
        this.swiperList = dataList.swiperList
        this.buttonList = dataList.button
        this.sectionSwiper = dataList.sectionSwiper

        this.init();
        this.renderSwipers();
        this.hasSubmit();
        this.getSubjectList();
    },
    methods: {
        getSubjectList() {
            subjectList().then(res => {
                if (res.state == 1) {
                    this.subjectList = res.content || []
                    const defaultSubject = this.subjectList.find(item => item.isDefault);
                    this.currentSubjectId = defaultSubject.subjectId;
                }
            })
        },
        async hasSubmit() {
            const { state, content = {} } = await fetchUserInfo();
            if (state == 1) {
                this.userInfo = content;
                if (!content || !content.hasPhone) return;
                const { state: innerState, content: innerContent = {} } = await judgeSubmit({ formId: "146" });
                if (innerState == 1) {
                    this.submitted = innerContent.submitted;
                }
            }
        },
        handleCutdownTime() {
            if (this.time == 0) {
                this.showMask = false;
                this.time = 5;
                this.handleSubmit();
                return;
            }
            setTimeout(() => {
                this.time--;
                this.handleCutdownTime();
            }, 1000)
        },
        init() {
            let option1 = {
                direction: 'horizontal',
                loop: true,
                speed: 1500,
                paginationType: 'bullets',
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 16,
            };
            this.$nextTick(() => {
                const swiper = new Swiper('.current-wrap', option1);
            });
        },
        renderSwipers() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 3000,
                paginationType: 'bullets',
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                autoplay: 5000,
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 16
            };
            this.$nextTick(() => {
                const swiper = new Swiper('.current-container', option);
            });
        },
        handleSubmit() {
            privateEducationV2({
                formId: "146",
                subjectId: this.currentSubjectId,
                referName: window && window.location.href || ''
            }).then(res => {
                const { state, content } = res || {}
                if (state == 1) {
                    content.retcode == 0 && handleJumpUrl(this.key)
                }
            }).finally(() => {
                this.showMask = false;
            })
        },
        handleChangeSubject(subjectId) {
            this.currentSubjectId = subjectId;
        },
        JumpFn(name) {
            let button_name = '领取详细课程大纲'
            if(name && typeof name ==='string'){
                button_name = name
            }
            this.eduPlatTrack('WebButtonClick', {
                'page_id': 'k1sah',
                'button_name': button_name
            });
            if (!this.userInfo || !this.userInfo.hasPhone) {
                handleJumpUrl(this.key);
            } else {
                if (this.submitted) {
                    handleJumpUrl(this.key);
                } else {
                    this.showMask = true;
                    this.handleCutdownTime();
                }
            }
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
    width: 100%;
    background: #F3F4FF;
    padding-bottom: 100px;
    &.pd-bot {
        padding-bottom: 165px;
    }
    .section {
        position: relative;
        width: 100%;
        .img {
            width: 100%;
            display: block;
        }
        .activityImg {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            width: 157px;
            height: 158px;
            img {
                width: 100%;
            }
        }
        .btn-more {
            position: absolute;
            bottom: 40px;
            left: 50%;
            transform: translate(-50%);
            background-color:transparent;
            border: none;
            z-index: 9;
            width: 464px;
            height: 88px;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    .sw1 {
        position: absolute;
        left: 0;
        top: 260px;
        padding: 0 30px 0 57px;
        box-sizing: border-box;
        width: 100%;
        /deep/ .current-wrap {
            width: 100%;
            height: 10.507rem;
            .swiper-slide {
                width: 4.8rem;
                img {
                    display: block;
                    width: 4.8rem;
                }
            }
        }
    }
    .sw {
        position: absolute;
        left: 0;
        top: 300px;
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        /deep/ .current-container {
            width: 100%;
            height: 5.227rem;
            .swiper-slide {
                width: 7.76rem;
                img {
                    display: block;
                    width: 7.76rem;
                }
            }
        }
    }

    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        .img {
            width: 100%;
            display: block;
        }
        .H5activityIcon {
            position: absolute;
            top: -50px;
            right: 42px;
            width: 209px;
        }
    }

    .img-top {
      margin-top: 40px;
    }
}
.form-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    z-index: 9999;
    .mask-content {
        position: absolute;
        left: 20px;
        bottom: 20px;
        width: 710px;
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        padding: 0 28px 30px;
        box-sizing: border-box;
        .mask-header {
            display: flex;
            width: 100%;
            height: 120px;
            line-height: 120px;
            box-sizing: border-box;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #333333;
            align-items: center;
            justify-content: space-between;
            .time {
                width: 71px;
                height: 71px;
                border: 1px solid #E5E5E5;
                border-radius: 50%;
                line-height: 71px;
                text-align: center;
                font-size: 28px;
                font-weight: 400;
                color: #E5A817;
            }
        }
        .subject-content {
            display: flex;
            width: 100%;
            padding: 21px 0 37px;
            flex-wrap: wrap;
            box-sizing: border-box;
            .subject-item {
                width: 204px;
                height: 80px;
                border-radius: 4px;
                line-height: 80px;
                text-align: center;
                background-color: #F8F9FA;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: #333333;
                margin-bottom: 20px;
                margin-right: 20px;
                box-sizing: border-box;
                border: 1px solid #F8F9FA;
                &:nth-child(3n) {
                    margin-right: 0;
                }
                &.actived {
                    border: 1px solid #FCD766;
                    background-color: rgba(252, 215, 102, 0.04);
                    color: #E5A817;
                }
            }
        }
        .mask-btn {
            height: 88px;
            line-height: 88px;
            text-align: center;
            background: linear-gradient(90deg, #FDE47C 0%, #FBC546 100%);
            border-radius: 4px;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #333333;
        }
    }
}
</style>
